import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonModal,
} from "@ionic/react";
import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import CancelModal from "../../components/modals/cancel-modal";
import { ActionType } from "../../models/Enums";

const SignupEmail: React.FC = () => {
  const [cancelModal, setCancelModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  async function checkDisableTextValidity(typedValue: string) {
    //  //;
    if (typedValue !== "" && typedValue.trim().length !== 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }

  function handleChange(event: any) {
    checkDisableTextValidity(event.target.value);
  }

  let history = useHistory();
  const {
    register,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });
  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="cancel-modal"
        backdropDismiss={false}
        isOpen={cancelModal}
        placeholder={undefined}
      >
        <CancelModal
          setShowModal1={setCancelModal}
          actionType={ActionType.NewUser}
          reset={reset}
          isEdit={false}
        ></CancelModal>
      </IonModal>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container top-spacing" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="top-inner-sec login-pages-space">
                <h1>New User Sign Up</h1>
                <p>Please enter the email associated with your account.</p>
              </div>
              <form onSubmit={handleSubmit((data) => {})} autoComplete="off">
                <div className={`field-wrap ${errors.email && "error-wrap"}`}>
                  <IonLabel className="label" placeholder={undefined}>
                    Email *
                  </IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="workemail@email.com"
                    {...register("email", {
                      required: true,
                      // maxLength: 50,
                      pattern:
                            /^[a-zA-Z0-9._+-]+@((\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|([a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))$/,
                    })}
                    onIonChange={(e) => {
                      handleChange(e);
                    }}
                  ></IonInput>
                </div>
                <div className="btn-wrap-sec extra-btn-space-wrap">
                  <IonButton
                    className="generic-btn generic-btn-outline"
                    onClick={() => setCancelModal(true)}
                    placeholder={undefined}
                  >
                    Cancel
                  </IonButton>
                  <IonButton
                    className="generic-btn disable-btn"
                    type="submit"
                    placeholder={undefined}
                  >
                    Confirm
                  </IonButton>
                </div>
              </form>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
export default SignupEmail;
